import { Check, AlertTriangle, X } from 'lucide-react';
import type { VerificationItem } from '../lib/types';
import styles from './VerificationList.module.css';

const iconMap = {
  pass: Check,
  flag: AlertTriangle,
  fail: X,
} as const;

const colorMap: Record<VerificationItem['status'], string> = {
  pass: 'var(--tia-positive)',
  flag: 'var(--tia-warning)',
  fail: 'var(--tia-negative)',
};

export function VerificationList({ items, className }: { items: VerificationItem[]; className?: string }) {
  return (
    <ul className={[styles.list, className].filter(Boolean).join(' ')}>
      {items.map((it) => {
        const Icon = iconMap[it.status];
        return (
          <li key={it.label} className={styles.item}>
            <span className={styles.iconWrap} style={{ color: colorMap[it.status] }}>
              <Icon size={14} strokeWidth={2} />
            </span>
            <div className={styles.body}>
              <span className={styles.label}>{it.label}</span>
              {it.note && <span className={styles.note}>{it.note}</span>}
            </div>
            <span className={styles.status} style={{ color: colorMap[it.status] }}>
              {it.status}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
